/**
 * Base Directive
 * 
 * @copyright NIIT Technologies Ltd. 2017-18
 */
// Angular
import {
    Component, Injectable, Inject, ReflectiveInjector, NgZone,
    ElementRef, Renderer, OnInit, OnDestroy, AfterContentInit, AfterViewInit
} from '@angular/core';
//

/**
 * Base Directive for All Directives
 */
export abstract class BaseDirective implements OnInit, OnDestroy, AfterContentInit, AfterViewInit {

    /**
     * Initialize
     */
    constructor(private zone: NgZone, private element: ElementRef, private renderer: Renderer) {
    }

    /**
     * Is Touch Device
     */
    protected isTouchDevice(): boolean {
        return ('ontouchstart' in window);
    }

    /**
      * On Initialization
      */
    public ngOnInit() {
    }

    /**
     * After Content Initialization
     */
    public ngAfterContentInit() {
    }

    /**
     * After View Initialization
     */
    public ngAfterViewInit() {
    }

    /**
     * On Destroy
     */
    public ngOnDestroy() {
    }

    /**
     * Fire Dummy Event on Element
     */
    protected fireDummyEvent() {
        if (this.renderer) {
            let htmlEvent = document.createEvent("HTMLEvents");
            //
            htmlEvent.initEvent("input", true, true);
            //
            this.renderer.invokeElementMethod(this.element.nativeElement, 'dispatchEvent', [htmlEvent]);
        }
    }

}